import { deleteApiWithData, getApi, putApi } from 'apis';
import ConfirmDelete from 'components/Global/confirmDeleteModel';
import { roleColumns } from 'constants/Data';
import { ChangeEvent, useEffect, useState } from 'react';
import { toastText } from 'utils/utils';
import { SideDrawerWrapper } from '../../../../src/components/Global';
import AddRoleBody from './AddRoleBody';
import CustomTable from './CustomTable';
import PermissionBody from './PermissionBody';
import styles from './index.module.scss';

const RoleTable = () => {
	const [drawerAnimation, setDrawerAnimation] = useState<boolean>(false);
	const [isSideDrawerOpen, setSideDrawerOpen] = useState<boolean>(false);
	const [selectedRole, setSelectedRole] = useState<any>(null);
	const [sort, setSort] = useState('asc');
	const [isPermissionDrawerOpen, setPermissionSideDrawerOpen] =
		useState<boolean>(false);
	// const [filteredData, setFilterData] = useState([]);
	const [currentPage, setCurrentPage] = useState(1);
	const [searchValue, setSearchValue] = useState('');
	const [filterValue, setFilterValue] = useState('all');
	const [drawerInfo, setDrawerInfo] = useState({
		drawerTitle: 'Add Role',
	});
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [sortDirection, SetsortDirection] = useState('ascend');
	const [PageSize, setPageSize] = useState(10);
	const [permissions, setPermissions] = useState([]);
	const [roles, setRoles] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [editSelectedRole, setEditSelectedRole] = useState<any>();
	const [isDeleteLoading, setIsDeleteLoading] = useState<boolean>(false);
	const [isCopyRole, setIsCopyRole] = useState<boolean>(false);

	useEffect(() => {
		// Initialize page size from local storage
		const pageSizeFromLocalStorage = localStorage.getItem('roleTableSize');
		if (pageSizeFromLocalStorage !== null) {
			setPageSize(parseInt(pageSizeFromLocalStorage));
		}
	}, []);

	// Remove from drawer handler
	const removeDrawerFromDom = () => {
		setSideDrawerOpen(false);
		setPermissionSideDrawerOpen(false);
	};
	// For open the sideDrawer with animation
	const openDrawerHandler = () => {
		setDrawerAnimation(true);
		setSideDrawerOpen(true);
	};

	// For open the sideDrawer with animation
	const openPermissionsHandler = () => {
		setDrawerAnimation(true);
		setPermissionSideDrawerOpen(true);
	};
	// For perform the close animation
	const closeDrawerByAnimation = () => {
		setDrawerAnimation(false);
		setPermissions([]);
		setEditSelectedRole(null)
		setIsCopyRole(false)
	};

	// Handle the pagination for the table
	const paginationChangeHandler = (pageNo: number, pageSize: number) => {
		setCurrentPage(pageNo);
		setPageSize(pageSize);
	};

	// For perform the search operation
	const performSearchHandler = (event: ChangeEvent<HTMLInputElement>) => {
		const { value } = event.target;
		setSearchValue(value);
		setCurrentPage(1);
	};

	// Perform Filter
	const performFilterHandler = (value: any) => {
		setFilterValue(value);
		setCurrentPage(1);
	};

	// For perform the sorting operation
	const performSortHandler = (sortType: string) => {
		if (sortType !== sortDirection) {
			SetsortDirection(sortType);
			setSort(sortType === 'ascend' ? 'asc' : 'desc');
			setCurrentPage(1);
		}
	};

	// To modify the pageSize
	const modifyPageSize = (current: number, size: number) => {
		if (!size) {
			setPageSize(10);
		} else {
			setPageSize(size);
			localStorage.setItem('roleTableSize', size.toString());
			setCurrentPage(1);
		}
	};

	//   For open the model
	const showModal = () => {
		setIsModalOpen(true);
	};

	// For change the data and title between components
	const setDrawerInfoHandler = (drawerTitle: any) => {
		setDrawerInfo({ drawerTitle });
	};

	//   For conform operation
	const handleOk = () => {
		setIsModalOpen(false);
	};

	//   For cancel operation
	const handleCancel = () => {
		setIsModalOpen(false);
		setEditSelectedRole(null)
	};

	// For fetch the all permission of some role
	const fetchRolePermissions = async (permissionDetails: any) => {
		setSelectedRole(permissionDetails);

		try {
			const permissions = await getApi(
				`/permission/${permissionDetails.id}`
			);
			setPermissions(permissions?.data.data);
		} catch (err) {
			console.log('err: ', err);
		}
	};

	const fetchRoles = async () => {
		setIsLoading(true);
		try {
			const query = {
				page: currentPage,
				limit: PageSize,
				search: searchValue,
				sort: sort,
			};

			const roles = await getApi('/role', query);
			setRoles(roles.data.data);
		} catch (err: any) {
			toastText(err?.response?.data?.error?.errorDescription, 'error');
		} finally {
			setIsLoading(false);
		}
	};

	const deleteHandler = async () => {
		if (editSelectedRole) {
			try {
				setIsDeleteLoading(true);
				const resp = await deleteApiWithData(`${`/role`}`, { roleId: editSelectedRole.id });
				toastText(resp?.data?.message ?? 'Something went wrong in delete user', 'success');
			} catch (error: any) {
				toastText(error.response?.data?.message ?? 'Something went wrong in delete user', 'error');
			} finally {
				handleCancel();
				fetchRoles();
				setIsDeleteLoading(false);
			}
		}
	};

	const updateStatusHanler = async (e: any, data: any) => {
		const updatedData = {
			roleId: data.id,
			status: e
		}
		try {
			setIsLoading(true);

			const updateStatus = await putApi(`/role/update-status`, updatedData)

			toastText(updateStatus?.data?.message ?? 'User status updated successfully.', 'success');
			setIsLoading(false);
		} catch (error: any) {
			toastText(error?.response?.data?.message ?? 'Something went wrong in update user status.', 'error');
		}
	}

	useEffect(() => {
		fetchRoles();
	}, [currentPage, PageSize, filterValue, searchValue, sort]);

	return (
		<>
			<div className={styles['role-table']}>
				<>
					{/* <TableActionHeader title={'Roles'}>
						<div className={styles['role-table__action']}> </div>
					</TableActionHeader> */}
					<div>
						<CustomTable
							roleDataSource={roles}
							roleColumns={roleColumns}
							paginationChangeHandler={paginationChangeHandler}
							currentPage={currentPage}
							totalRecords={30}
							performSearchHandler={performSearchHandler}
							searchValue={searchValue}
							showModal={showModal}
							openDrawerHandler={openDrawerHandler}
							setDrawerInfoHandler={setDrawerInfoHandler}
							openPermissionsHandler={openPermissionsHandler}
							fetchRolePermissions={fetchRolePermissions}
							performSortHandler={performSortHandler}
							performFilterHandler={performFilterHandler}
							filterValue={filterValue}
							permissions={[]}
							PageSize={PageSize}
							modifyPageSize={modifyPageSize}
							sortDirection={sortDirection}
							isLoading={isLoading}
							setEditSelectedRole={setEditSelectedRole}
							setIsCopyRole={setIsCopyRole}
							updateStatusHanler={updateStatusHanler}
						/>
					</div>
				</>
			</div>
			<ConfirmDelete
				handleCancel={handleCancel}
				handleOk={handleOk}
				isModalOpen={isModalOpen}
				deleteHandler={deleteHandler}
				isLoading={isDeleteLoading}
			/>
			{isSideDrawerOpen && (
				<SideDrawerWrapper
					isOpen={drawerAnimation}
					removeDrawerFromDom={removeDrawerFromDom}
					closeDrawerByAnimation={closeDrawerByAnimation}
					headerTitle={drawerInfo.drawerTitle}
					position="right"
					width="half"
				>
					<AddRoleBody
						closeDrawerByAnimation={closeDrawerByAnimation}
						fetchRoles={fetchRoles}
						editSelectedRole={editSelectedRole}
						copyrole={isCopyRole}
					/>
				</SideDrawerWrapper>
			)}
			{isPermissionDrawerOpen && (
				<SideDrawerWrapper
					isOpen={drawerAnimation}
					removeDrawerFromDom={removeDrawerFromDom}
					closeDrawerByAnimation={closeDrawerByAnimation}
					headerTitle={drawerInfo.drawerTitle}
					position="right"
					width="half"
				>
					<PermissionBody
						closeDrawerByAnimation={closeDrawerByAnimation}
						permissions={permissions}
						selectedRole={selectedRole}
						isLoading={permissions?.length > 0 ? false : true}
					/>
				</SideDrawerWrapper>
			)}
		</>
	);
};

export default RoleTable;
